import { MatTabGroup } from '@angular/material/tabs';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NavService } from '../services/nav.service';
import { LibService } from '../services/libService';
import { ConfService } from '../services/conf.service';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { TranslatorService } from '../services/translate.service';
import { WikiService } from '../services/wikiservice.service';

@Component({
  selector: 'app-gen-config',
  templateUrl: './gen-config.component.html',
  styleUrls: ['./gen-config.component.scss']
})
export class GenConfigComponent implements OnInit, AfterViewInit {
  title = "Configurazione";
  subTitle = "EDAC - Configurazione sistema";
  form: UntypedFormGroup;
  confs!: Observable<any>;
  conf: any;
  toActivate: number;
  @ViewChild('configExpansionPanel') configExpansionPanel: MatExpansionPanel
  @ViewChild('configInnerExpansionPanel') configInnerExpansionPanel: MatExpansionPanel
  @ViewChild('configTabGroup') configTabGroup: MatTabGroup

  constructor(public navService: NavService, public wikiService: WikiService,public libService: LibService, private router: Router, private fb: UntypedFormBuilder, public confService: ConfService, private toastr: ToastrService, public translate: TranslatorService) {
    const previousRoute = this.router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString()
    if(previousRoute != undefined){
      if(previousRoute?.indexOf('/branch/') >= 0){
        this.toActivate = 1
      }
      if(previousRoute?.indexOf('/category/') >= 0){
        this.toActivate = 2
      }
      if(previousRoute?.indexOf('/macrophase/') >= 0){
        this.toActivate = 3
      }
      if(previousRoute?.indexOf('/phase/') >= 0){
        this.toActivate = 4
      }
    }else{
      this.toActivate = -1
    }
  }

  ngAfterViewInit(): void{
    setTimeout(() => {
      if(this.toActivate >= 0){
        this.configExpansionPanel?.open()
        this.configInnerExpansionPanel?.open()
        this.configTabGroup.selectedIndex = this.toActivate 
        // this.configTabGroup?.focusTab(this.toActivate)
      }
    }, 500)
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt: any) => console.log('NAVIGATION\n\n\n',evt))
    let self = this;
    this.translate.get('LABEL.CONFIG').subscribe(rt => {
      self.navService.setTitle(rt);
      self.title = rt;
      self.subTitle = "EDAC - " + rt;
      self.navService.setSubTitle( "EDAC - " + rt);
    });

    let actions: any;
    actions = [
      //{ name: 'export', url: '' },
    ];
    this.navService.setActions(actions);
    this.form = this.fb.group({
      utentiSilver: [0, [Validators.min(1), Validators.max(100)]],
      utentiBronze: [0, [Validators.min(1), Validators.max(100)]],
      utentiGold: [0, [Validators.min(1), Validators.max(100)]],
      costoSilver: [0, [Validators.min(1), Validators.max(100)]],
      costoBronze: [0, [Validators.min(1), Validators.max(100)]],
      costoGold: [0, [Validators.min(1), Validators.max(100)]],
      utentiSilver_l2: [0, [Validators.min(1), Validators.max(100)]],
      utentiBronze_l2: [0, [Validators.min(1), Validators.max(100)]],
      utentiGold_l2: [0, [Validators.min(1), Validators.max(100)]],
      costoSilver_l2: [0, [Validators.min(1), Validators.max(100)]],
      costoBronze_l2: [0, [Validators.min(1), Validators.max(100)]],
      costoGold_l2: [0, [Validators.min(1), Validators.max(100)]]
    });
    this.loadConfs();

  }

  goToWiki() {
    window.open(this.wikiService.getWikiUrl(this.navService.getWikiKey()));
  }

goToWikiByKey(k:any){
    window.open(this.wikiService.getWikiUrl(k));
  }

  get utentiBronze() { return this.form.get('utentiBronze'); }
  get utentiSilver() { return this.form.get('utentiSilver'); }
  get utentiGold() { return this.form.get('utentiGold'); }
  get utentiBronze_l2() { return this.form.get('utentiBronze_l2'); }
  get utentiSilver_l2() { return this.form.get('utentiSilver_l2'); }
  get utentiGold_l2() { return this.form.get('utentiGold_l2'); }

  update() {
    this.conf.n_utenti_lic_silver = parseInt(this.form.value.utentiSilver);
    this.conf.n_utenti_lic_bronze = parseInt(this.form.value.utentiBronze);
    this.conf.n_utenti_lic_gold = parseInt(this.form.value.utentiGold);
    this.conf.cost_lic_silver = parseInt(this.form.value.costoSilver);
    this.conf.cost_lic_bronze = parseInt(this.form.value.costoBronze);
    this.conf.cost_lic_gold = parseInt(this.form.value.costoGold);
    this.conf.n_utenti_lic_silver_l2 = parseInt(this.form.value.utentiSilver_l2);
    this.conf.n_utenti_lic_bronze_l2 = parseInt(this.form.value.utentiBronze_l2);
    this.conf.n_utenti_lic_gold_l2 = parseInt(this.form.value.utentiGold_l2);
    this.conf.cost_lic_silver_l2 = parseInt(this.form.value.costoSilver_l2);
    this.conf.cost_lic_bronze_l2 = parseInt(this.form.value.costoBronze_l2);
    this.conf.cost_lic_gold_l2 = parseInt(this.form.value.costoGold_l2);

    console.log('update lic from from %o to %o', this.form.value, this.conf);
    if (this.form.valid) {

      this.confService.updateConf(this.conf.id, this.conf).subscribe((response) => {
        this.libService.unlockPage();
        this.loadConfs();
        this.toastr.success(
          this.translate.instant('LABEL.OK'), this.translate.instant('LABEL.Info'));
        console.log(response);
      },
        err => {
          this.libService.unlockPage();
          this.toastr.error(this.translate.instant('TOASTR.MESSAGE_3'), this.translate.instant('TOASTR.WARNING'));
        });
    }
    else {
      this.toastr.error(this.translate.instant('TOASTR.MESSAGE_1'), this.translate.instant('TOASTR.WARNING'));
    }
  }


  loadConfs(): void {
    this.libService.lockPage('');
    this.confs = this.confService.getAllConfs();
    this.confs.subscribe(
      c => {
        console.log('get conf %o', c);
        this.libService.unlockPage();
        this.conf = c[0];
        this.form.patchValue({
          utentiSilver: c[0].n_utenti_lic_silver,
          utentiBronze: c[0].n_utenti_lic_bronze,
          utentiGold: c[0].n_utenti_lic_gold,
          costoSilver: c[0].cost_lic_silver,
          costoBronze: c[0].cost_lic_bronze,
          costoGold: c[0].cost_lic_gold,
          utentiSilver_l2: c[0].n_utenti_lic_silver_l2,
          utentiBronze_l2: c[0].n_utenti_lic_bronze_l2,
          utentiGold_l2: c[0].n_utenti_lic_gold_l2,
          costoSilver_l2: c[0].cost_lic_silver_l2,
          costoBronze_l2: c[0].cost_lic_bronze_l2,
          costoGold_l2: c[0].cost_lic_gold_l2
        });
      },
      err => {
        this.libService.unlockPage();
        this.toastr.error(this.translate.instant('TOASTR.MESSAGE_5'), this.translate.instant('TOASTR.WARNING'));
      }
    );
  }

}
